// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueImg from 'v-img'
import KsVueScrollmagic from 'ks-vue-scrollmagic'
import VueMasonry from 'vue-masonry-css'
import vBEM from './v-bem.js'
import VueBgSrc from 'vue-bg-src'

const mediaQueries = {
  ss: '(min-width: 576px)',
  ms: '(min-width: 768px)',
  ls: '(min-width: 992px)',
  xs: '(min-width: 1400px)'
}
Vue.use(VueBgSrc, {mediaQueries: mediaQueries})
Vue.use(VueMasonry)
Vue.use(vBEM, {})

require('normalize.css')

Vue.use(VueImg)
Vue.use(KsVueScrollmagic)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js